import * as React from "react";
import styled from "styled-components";
import { create, windowScheduler, keyResolver } from "@yornaath/batshit";
import { useQuery } from "@tanstack/react-query";
import { SystemCatalog } from "@graylog/server-api";
import { Spinner } from "components/common";
import { MISSING_BUCKET_NAME } from "views/Constants";
const assetNames = create({
  fetcher: (ids) => SystemCatalog.getTitles({
    entities: ids.map((id) => ({
      id,
      type: "assets",
      identifier_type: void 0,
      display_template: void 0,
      identifier_field: void 0,
      display_fields: void 0
    }))
  }).then(({ entities }) => entities),
  resolver: keyResolver("id"),
  scheduler: windowScheduler(10)
});
const useAssetName = (assetId) => {
  const isMissingBucket = assetId === MISSING_BUCKET_NAME;
  const { data, isInitialLoading } = useQuery({
    queryKey: ["assets", "name", assetId],
    queryFn: () => assetNames.fetch(assetId),
    enabled: !isMissingBucket
  });
  return isMissingBucket ? { data: assetId, isInitialLoading: false } : {
    data: data == null ? void 0 : data.title,
    isInitialLoading
  };
};
const AssetName = ({ assetId }) => {
  const { data: assetName, isInitialLoading } = useAssetName(assetId);
  if (isInitialLoading) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Spinner, { size: "sm" }));
  }
  return /* @__PURE__ */ React.createElement("span", { title: assetId }, assetName != null ? assetName : assetId);
};
const AssetsList = styled.span`
  span:not(:last-child)::after {
    content: ', ';
  }
`;
const AssetsField = ({ value }) => Array.isArray(value) ? /* @__PURE__ */ React.createElement(AssetsList, null, value.map((assetId) => /* @__PURE__ */ React.createElement(AssetName, { assetId, key: assetId }))) : /* @__PURE__ */ React.createElement(AssetName, { assetId: value, key: value });
export default AssetsField;
